import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';

import { Homepage } from './components/Homepage';
import { FramesPage } from './components/FramesPage';
import { ServalPage } from './components/ServalPage';
import { BengalPage } from './components/BengalPage';
import { BlackfootPage } from './components/BlackfootPage';
import { PartsPage } from './components/PartsPage';
import { JokerPage } from './components/JokerPage';
import { FontsPage } from './components/FontsPage';
import { MaverickPage } from './components/MaverickPage';
import { MainframePage } from './components/MainframePage';
import { GuideArticlePage } from './components/GuideArticlePage';
import { GuidesPage } from './components/GuidesPage';
import { SEO } from './components/SEO';

// ========================================

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
	<BrowserRouter>
		<SEO />
		<Routes>
			<Route path="/" element={<Homepage />} />
			<Route path="/frames" element={<FramesPage />} />
			<Route path="/frames/serval" element={<ServalPage />} />
			<Route path="/frames/bengal" element={<BengalPage />} />
			<Route path="/frames/blackfoot" element={<BlackfootPage />} />
			<Route path="/parts" element={<PartsPage />} />
			<Route path="/parts/joker" element={<JokerPage />} />
			<Route path="/fonts" element={<FontsPage />} />
			<Route path="/fonts/maverick" element={<MaverickPage />} />
			<Route path="/fonts/mainframe" element={<MainframePage />} />
			<Route path="/guides" element={<GuidesPage />} />
			<Route path="/guides/:slug" element={<GuideArticlePage />} />
		</Routes>
	</BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
